const TABS = [
  { value: "medios", label: "Medios" },
  { value: "fotografo", label: "Fotógrafos" },
];

const AcreditacionTabs = ({ value, onChange }) => {
  return (
    <div className="general-container">
      <div className="acreditacion-tabs-wrapper">
        <div className="acreditacion-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.value}
              className={`acreditacion-tab btn ${value === tab.value ? "active" : ""}`}
              onClick={() => onChange(tab.value)}
            >
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AcreditacionTabs;
